export default "__VITE_ASSET__7cd55cd8__"